import { makeStyles } from '@material-ui/core/styles';
import { COLORS, FONTS } from '../../../constants';

// eslint-disable-next-line no-unused-vars
const styles = theme => ({
  textRoot: {
    fontFamily: FONTS.PRIMARY,
    fontWeight: 300,
    marginBottom: '10px',
  },
  root: {
    fontFamily: FONTS.PRIMARY,
    color: COLORS.GREY_DARK,
  },
  suggestionsContainer: {
    border: `1px solid ${COLORS.GREY}`,
    borderTop: 'none',
    borderBottom: 'none',
  },
  suggestionItem: {
    cursor: 'pointer',
    padding: '8px 10px',
    borderBottom: `1px solid ${COLORS.GREY}`,
  },
  suggestionItemActive: {
    backgroundColor: COLORS.GREY,
  },
  input: {
    color: COLORS.GREEN,
    fontSize: '1rem',
    '& .MuiInput-underline:after': {
      borderBottomColor: '#fff', // Solid underline on focus
    },
  },
  label: {
    fontWeight: '400',
    color: COLORS.GREEN,
    fontSize: '1rem',
  },
  labelFocused: {
    color: COLORS.GREEN,
    fontWeight: '600',
    fontSize: '1rem',
  },
  labelDisabled: {
    fontWeight: '400',
    fontSize: '1rem',
    color: 'red',
  },
  labelShrink: {
    fontWeight: '400',
    fontSize: '1rem',
    color: COLORS.GREEN,
  },
});

export const useStyles = makeStyles(() => ({
  inputUnderline: {
    '&:before': {
      borderBottom: `2px solid ${COLORS.GREY}`,
    },
  },
  inputLabel: {
    color: COLORS.GREY_DARK,
    fontSize: '1rem',
    fontWeight: '400',
    '&.focused': {
      color: COLORS.GREEN,
      textTransform: 'uppercase',

      fontWeight: '600',

      borderBottomColor: COLORS.GREEN,
    },
    '&.focused.Mui-error': {
      color: '#f44336',
    },
  },
  labelShrink: {
    fontWeight: '600',
    fontSize: '1rem',
    color: COLORS.GREY_DARK,
    textTransform: 'uppercase',
    position: 'relative',
    marginBottom: '-20px',
  },
}));

export default styles;
